export default __webpack_public_path__ + "static/media/loadingmobile3.1a691221.gif";